import { logUiClickEventHelper } from '_acaSrc/utility/Events';

export const EMAIL_VERIFICATION_EVENTS = Object.freeze({
    onNetworkRequiredModalPresented: 'emailVerification_onNetworkRequiredModalPresented',
    resendBtn: 'emailVerification_ui_resendBtn',
    verifyBtn: 'emailVerification_ui_verifyBtn',
    success: 'emailVerification_ui_success',
    skipBtn: 'emailVerification_ui_skipBtn',
    backBtn: 'emailVerification_ui_backBtn',
    logoClick: 'emailVerification_ui_logoClick'
});

const withDefinedValues = (payload) => Object.fromEntries(
    Object.entries(payload).filter(([ , value ]) => value !== undefined)
);

export const trackRegistrationEmailVerifyUiEvent = (uiElementName, payload = {}) => {
    if (!uiElementName) {
        return;
    }
    logUiClickEventHelper({
        uiElementName,
        optData: withDefinedValues(payload)
    }); 
};

export const trackOnNetworkRequiredModalPresented = () => {
    trackRegistrationEmailVerifyUiEvent(
        EMAIL_VERIFICATION_EVENTS.onNetworkRequiredModalPresented,
        {
            action: 'on-network-required-modal-presented',
            flow: 'on-network-required',
            screen: 'on-network-verification-banner',
            timestamp: new Date().toISOString()
        }
    );
};
